var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMongolia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C17.9571 32 19.8319 31.648 21.5652 31.0048L22.2609 16L21.5653 0.995188C19.8319 0.352063 17.9571 0 16 0C14.0429 0 12.1681 0.352063 10.4348 0.995188L9.73914 16L10.4348 31.0048C12.1681 31.648 14.0429 32 16 32Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.9999C0 22.8794 4.342 28.7441 10.4348 31.0047V0.995117C4.342 3.2558 0 9.12049 0 15.9999Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 0.995117V31.0048C27.658 28.7441 32 22.8794 32 15.9999C32 9.12049 27.658 3.2558 21.5652 0.995117Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.65219 16H9.0435V21.5652H7.65219V16Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08694 16H3.47826V21.5652H2.08694V16Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5652 19.4784C6.3336 19.4784 6.95651 18.8555 6.95651 18.0871C6.95651 17.3187 6.3336 16.6958 5.5652 16.6958C4.7968 16.6958 4.17389 17.3187 4.17389 18.0871C4.17389 18.8555 4.7968 19.4784 5.5652 19.4784Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5648 13.913C5.94898 13.913 6.26042 13.6015 6.26042 13.2174C6.26042 12.8332 5.94898 12.5217 5.5648 12.5217C5.18061 12.5217 4.86917 12.8332 4.86917 13.2174C4.86917 13.6015 5.18061 13.913 5.5648 13.913Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17395 20.1741H6.95658V21.5654H4.17395V20.1741Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17395 14.6089H6.95658V16.0002H4.17395V14.6089Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56548 8.3479L6.05823 9.86415H7.65248L6.3628 10.8013L6.85517 12.3175L5.56548 11.3804L4.27586 12.3175L4.76823 10.8013L3.47855 9.86415H5.0728L5.56548 8.3479Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMongolia);
export default __webpack_public_path__ + "static/media/flag_mongolia.e9debc031a4d5ef899bdf6a461cbe780.svg";
export { ForwardRef as ReactComponent };